import React from 'react';
import {
    Card, Button, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, CardFooter, CardHeader, CardColumns, CardDeck
} from 'reactstrap';
import { decompressToBase64, formatter } from '../../utils/common'
import Modal from 'react-modal';
import ItemModal from '../Items/ItemModal.js'
import image from "../No_image_available.png";
import { GetCart } from '../ShoppingCart/CartHandler.js';
import parse from 'html-react-parser';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import axios from 'axios';
import "./ItemSearchResults"


const apiUrl = process.env.REACT_APP_BASEURL;

function ItemSearchResults(props) {

    const [activeItem, setActiveItem] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [foundItems, setFoundItems] = useState();
    // const [startCard, setStartCard] = useState(0);
    // const [endCard,setEndCard] = useState(5);
    // const [popCards, setPopCards] = useState(results);
    // const [currPopCards, setCurrPopCards] = useState([]);
    let category = 'All'
    const navigate = useNavigate();


    const FindItems = () => {

        axios
            .get(apiUrl + `/api/Items/SearchItems?search=${props.search}`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {

                // console.log("Item Search Response:", response.data);

                setFoundItems(response.data);// Make sure response.data is an array

            })
            .catch((error) => {
                console.log(error);
            });
    };


    if (!!sessionStorage.getItem("category")) {
        category = sessionStorage.getItem("category")
    }

    const encodedValue = encodeURIComponent(category);


    useEffect(() => {
        FindItems();
    }, [props.search]);


    let onRequestClose = () => {
        setIsOpen(false);
        // setCartFunc(GetCart);

    }

    let handleClick = (item) => {
        setActiveItem(item);
        setIsOpen(true);
    }

    let handleMenuClick = (catName) => {
        let parentCategory = props.categories.find(category =>
            category.children.some(child => child.name === catName)
        );
        props.setCategory(parentCategory);
        navigate("/CategorySearchResults");

    }



    const renderSearchResults = () => {
        if (foundItems === null) {
            return (<div>Awaiting Search Results.....</div>);
        } else {
            return (
                <div className="flex-col  scroll search-box">
                    <div
                        className="flex-row flex-wrap  margin-top10"
                        id="featItemsSpan"
                    >
                        {/* <button id="slideLeft" color="primary" onClick ={buttonLeftClick} >{String.fromCharCode(8249)}</button> */}
                       
                            {!!foundItems && foundItems.map(item =>
                                <Card className='' key={item.itemNumber} onClick={() => handleClick(item)}>
                                    <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
                                    <CardBody className="card-body">
                                        <CardTitle style={{ cursor: "pointer" }}>{item.itemNumber}</CardTitle><br />
                                        <CardSubtitle onClick={() => handleMenuClick(item.categoryName)}>{item.categoryName}</CardSubtitle>
                                        {item.available !== null ? <><CardText className="card-description-short w-[14rem]">{item.itemDescription}</CardText><CardText>{item.available}</CardText></> : <CardText className="card-description">{item.itemDescription}</CardText>}
                                    </CardBody>
                                    <CardFooter className="text-muted">{formatter.format(item.price)}</CardFooter>
                                </Card>
                            )}
                        {/* <button id="slideRight" color="primary" onClick ={buttonRightClick}>{String.fromCharCode(8250)}</button> */}
                        {isOpen ? <ItemModal item={activeItem} onRequestClose={onRequestClose} cartCount={props.cartCount} setCartCount={props.setCartCount} /> : null}
                    </div>
                </div>
            )
        }
    }
    return (<div>{renderSearchResults()}</div>)
}
export default ItemSearchResults;